<template>
    <div class="Card YourWines">
        <div class="Card__Head">
            <div class="Card__Head__Title">{{ $t('your-wines') }}</div>
        </div>
        <div class="Card__Content">
            <div class="v-tabs-wrapper your-wines">
                <v-tabs v-model="selectedRegionTab" fixed-tabs>
                    <v-tab key="region">{{ $t('region') }}</v-tab>
                    <v-tab key="colour">{{ $t('colour') }}</v-tab>
                </v-tabs>
                <v-tabs-items v-model="selectedRegionTab">
                    <v-tab-item>
                        <div class="region-wrapper">
                            <div class="left-side">
                                <RegionChart v-bind:getWineRegionNamesArr="getWineRegionNamesArr"
                                             v-bind:getInvestmentPercentRegionArr="getInvestmentPercentRegionArr"></RegionChart>
                                <span>{{ $t('calculated-by-market-value') }}</span>
                            </div>
                            <div class="right-side">
                                <ul class="chart-details-wrapper">
                                    <li v-for="region in regionList">
                                        <div class="wine-region-wrapper">
                                            <div class="square" :style="{'background-color': region.color}"></div>
                                            <p>{{ region.wineRegion }}</p>
                                        </div>
                                        <p>{{ region.investmentPercent }}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </v-tab-item>
                    <v-tab-item>
                        <div class="colour-wrapper">

                            <div class="colour-row" v-for="colour in colourList">
                                <span
                                    :class="{'red': colour.color === 'Red', 'white': colour.color === 'White', 'champagne': colour.color === 'Champagne', 'loader': 'loader'}"
                                    :style="{'width': colour.countOfBottlesOwnedPercentage + '%'}"></span>
                                <div class="content">
                                    <div class="heading">
                                        <div class="img">
                                            <svg width="11" height="22" viewBox="0 0 11 22" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg" v-if="colour.color === 'Red'">
                                                <path
                                                    d="M11.0007 6.34992C11.0007 8.96531 7.69644 17.5097 6.28956 21.0292C5.94964 21.8796 5.38491 21.8793 5.04488 21.0287C3.63789 17.5089 0.333984 8.96519 0.333984 6.34992C0.333984 3.02714 2.7218 0.333496 5.66732 0.333496C8.61284 0.333496 11.0007 3.02714 11.0007 6.34992Z"
                                                    fill="#8B0101"/>
                                            </svg>
                                            <svg width="12" height="22" viewBox="0 0 12 22" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg" v-if="colour.color === 'White'">
                                                <path
                                                    d="M11.3327 6.34992C11.3327 8.96531 8.02847 17.5097 6.62159 21.0292C6.28167 21.8796 5.71694 21.8793 5.37691 21.0287C3.96993 17.5089 0.666016 8.96519 0.666016 6.34992C0.666016 3.02714 3.05383 0.333496 5.99935 0.333496C8.94487 0.333496 11.3327 3.02714 11.3327 6.34992Z"
                                                    fill="#D7B981"/>
                                            </svg>
                                            <svg width="12" height="22" viewBox="0 0 12 22" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg" v-if="colour.color === 'Champagne'">
                                                <path
                                                    d="M11.3327 6.34992C11.3327 8.96531 8.02847 17.5097 6.62159 21.0292C6.28167 21.8796 5.71694 21.8793 5.37691 21.0287C3.96993 17.5089 0.666016 8.96519 0.666016 6.34992C0.666016 3.02714 3.05383 0.333496 5.99935 0.333496C8.94487 0.333496 11.3327 3.02714 11.3327 6.34992Z"
                                                    fill="#CB8C5E"/>
                                            </svg>
                                        </div>
                                        <div class="text-content">
                                            <h2>{{ $t(`${colour.color}`) }}</h2>
                                            <span>{{ colour.countOfBottlesOwned }} {{ $t('bottles') }}</span>
                                        </div>
                                    </div>
                                    <div class="value">
                                        <h2>+ {{ currencySign }} {{ colour.performanceAmount }}</h2>
                                        <span class="performance-rate green">
                                          <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M4 0.75L0.25 4.5H7.75L4 0.75Z" fill="#018671"/>
                                          </svg>
                                          {{ colour.performanceRate }}%
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </div>
    </div>
</template>

<script>
import RegionChart from "./RegionChart/RegionChart";
import {mapGetters} from "vuex";
import {GCommon} from "@/store/getters";

export default {
    name: "YourWines",
    components: {RegionChart},
    props: ['selectedRegionTab', 'regionList', 'colourList'],
    data() {
        return {
            getWineRegionNamesArr: [],
            getInvestmentPercentRegionArr: []
        }
    },
    computed: {
        ...mapGetters({
            currencySign: GCommon.GET_CURRENCY_SIGN,
        })
    },
    created() {
        let wineRegionNames = this.regionList.map(item => item.wineRegion);
        let investmentPercentageRegion = this.regionList.map(item => item.investmentPercent);

        wineRegionNames.map(item => this.getWineRegionNamesArr.push(item))
        investmentPercentageRegion.map(item => this.getInvestmentPercentRegionArr.push(parseFloat(item)))
    }
}
</script>

<style>
.Card.YourWines .v-window.v-item-group.theme--light.v-tabs-items {
    margin-top: 20px;
    flex: 1 1 auto;
    width: 100%;
    padding: 0;
}

.Card.YourWines .v-slide-group__content {
    border: none;
    background: rgba(0, 0, 0, 0.04);
    height: 32px;
    border-radius: 4px;
}

.Card.YourWines .v-tabs-bar {
    max-width: 100% !important;
    width: 100%;
    margin: 0 auto;
}

.Card.YourWines .v-tab {
    font-weight: 600;
}

.Card.YourWines .v-tab.v-tab--active {
    background-color: var(--white) !important;
    border-radius: 4px;
}
</style>

<style scoped>

.region-wrapper,
.colour-wrapper {
    display: flex;
    align-items: center;
}

.region-wrapper span {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 9px;
    line-height: 10px;
    margin-top: 10px;
}

.colour-wrapper {
    flex-direction: column;
}

/*Region TAB*/
.region-wrapper .left-side,
.region-wrapper .right-side {
    flex: 1;
}

.region-wrapper .left-side {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.chart-details-wrapper {
    padding: 0;
    margin: 0;
}

.chart-details-wrapper li {
    display: flex;
    align-items: center;
    margin: 0;
}

.chart-details-wrapper li + li {
    margin-top: 15px;
}

.chart-details-wrapper li .wine-region-wrapper {
    flex: 1;
    display: flex;
    align-items: center;
}

.chart-details-wrapper li .wine-region-wrapper .square {
    width: 9px;
    height: 9px;
    border-radius: 2px;
    margin-right: 10px;
}

.chart-details-wrapper li p {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: var(--black);
    margin: 0;
}

/*Region TAB END*/

/*Colour TAB*/
.colour-row {
    border-radius: 4px;
    flex: 1;
    padding: 12px;
    position: relative;
    width: 100%;
}

.colour-row + .colour-row {
    margin-top: 10px;
}

.colour-row .loader {
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 4px;
    z-index: 2;
}

.colour-row .loader.red {
    background: rgba(139, 1, 1, .05) !important;
}

.colour-row .loader.white {
    background: rgba(215, 185, 129, .2) !important;
}

.colour-row .loader.champagne {
    background: rgba(203, 140, 94, .15) !important;
}

.colour-row .content {
    z-index: 100;
    color: rgba(0, 0, 0, 0.88);
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.colour-row .content .heading {
    display: flex;
    align-items: center;
}

.colour-row .content .heading .img {
    margin-right: 20px;
}

.colour-row .content h2 {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
}

.colour-row .content span {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
}

.colour-row .content .value {
    display: flex;
    flex-direction: column;
    text-align: right;
    align-items: flex-end;
}

.colour-row .content .value .performance-rate {
    display: flex;
    align-items: center;
}

.colour-row .content .value .performance-rate svg {
    margin-right: 5px;
}

.colour-row .content .value .performance-rate.green {
    color: #018671;
    background-color: transparent !important;
    border-color: transparent !important;
}

.colour-row .content .value .performance-rate.red {
    color: #D5394F;
    background-color: transparent !important;
    border-color: transparent !important;
}

/*Colour TAB END*/
</style>
